module.exports = "../dist/img/img_4-27.17ba.jpg";